var React = require('react');

function QuoteLeft (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"quote-left"),React.createElement("path",{"d":"M0,0Q0,9.58.05,10.68.2,19.67,2.77,24t8.75,4.32l1.58-4.77q-3.36,0-4.6-2.5c-.82-1.68-1.23-4.35-1.23-8h6.28V0Z","style":{"fill":"#97c14c"},"key":1}),React.createElement("path",{"d":"M18.81,0c0,6.39,0,10,.05,10.68q.15,9,2.72,13.31t8.75,4.32l1.58-4.77q-3.36,0-4.6-2.5c-.82-1.68-1.23-4.35-1.23-8h6.28V0Z","style":{"fill":"#97c14c"},"key":2})]);
}

QuoteLeft.defaultProps = {"width":"32.36","height":"28.31","viewBox":"0 0 32.36 28.31"};

module.exports = QuoteLeft;

QuoteLeft.default = QuoteLeft;
